import React from 'react';
import Icon from '../../../components/AppIcon';


const FoundingVisionSection = () => {
  const visionPoints = [
    {
      icon: "Target",
      title: "Strategic Independence",
      description: "Every organization deserves to control their AI destiny without being held hostage by proprietary vendors and their ever-changing pricing models."
    },
    {
      icon: "Code",
      title: "Open-Source Superiority",
      description: "Open-source AI isn't a compromise—it's the superior choice for enterprises that value transparency, customization, and long-term sustainability."
    },
    {
      icon: "Users",
      title: "Internal Capability Building",
      description: "True AI transformation comes from building internal expertise and capabilities, not from outsourcing critical thinking to external vendors."
    },
    {
      icon: "Shield",
      title: "Vendor Lock-in Liberation",
      description: "We've witnessed too many organizations trapped by proprietary solutions. Our mission is to provide a clear path to AI freedom."
    }
  ];

  return (
    <section className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-flex items-center space-x-2 bg-brand-primary/10 rounded-full px-4 py-2 mb-6">
              <Icon name="Lightbulb" size={16} className="text-brand-primary" />
              <span className="text-sm font-medium text-brand-primary">Our Founding Vision</span>
            </div>
            
            <h2 className="text-3xl lg:text-4xl font-bold text-text-primary mb-6">
              Born from Frustration with
              <span className="block text-brand-primary">Vendor Dependency</span>
            </h2>
            
            <p className="text-lg text-text-secondary mb-8 leading-relaxed">
              AI Clean Core was founded in 2019 when our team witnessed enterprise after enterprise falling into the same trap: trading short-term convenience for long-term dependency. We saw brilliant organizations become prisoners of their own AI infrastructure, unable to innovate or adapt without vendor permission.
            </p>
            
            <p className="text-lg text-text-secondary mb-8 leading-relaxed">
              Our founders, having led AI transformations at Fortune 500 companies, recognized that the future belongs to organizations that own their AI capabilities. We established AI Clean Core to be the bridge between where enterprises are today and where they need to be: completely independent and in control of their AI destiny.
            </p>
            
            <div className="bg-brand-surface rounded-xl p-6 border-l-4 border-brand-primary">
              <blockquote className="text-lg italic text-text-primary">
                "AI is too important to your organization's future to be controlled by someone else's business model."
              </blockquote>
              <cite className="block mt-3 text-sm text-text-secondary">
                — Sarah Chen, CEO & Co-Founder
              </cite>
            </div>
          </div>
          
          <div className="space-y-6">
            {visionPoints?.map((point, index) => (
              <div key={index} className="flex space-x-4 p-6 bg-white rounded-xl shadow-executive hover:shadow-executive-lg transition-all duration-300 border border-gray-100">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-brand-primary/10 rounded-lg flex items-center justify-center">
                    <Icon name={point?.icon} size={24} className="text-brand-primary" />
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-text-primary mb-2">
                    {point?.title}
                  </h3>
                  <p className="text-text-secondary leading-relaxed">
                    {point?.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FoundingVisionSection;